/* istanbul ignore next */
export async function importListOfAllCountries(): Promise<string[]> {
	const { listOfAllCountries } = await import('@app/shared/utils/list-of-all-countries');
	return listOfAllCountries;
}
